import * as api from "@/api/user";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { UserSignature } from "@/api/user";

export function useQualifierUser() {
  return useQuery(["user", "qualifier"], api.getQualifierUser);
}

export function useCoordinatorUser() {
  return useQuery(["user", "coordinator"], api.getCoordinatorUser);
}

export function useQualifierUserList() {
  return useQuery(["user", "list", "qualifier"], api.getQualifierUserList);
}

export function useGetUserSignatures() {
  return useQuery(["user", "signatures"], api.getUserSignatures, {
    // Fixes race condition with saving (file dialog triggers window focus)
    refetchOnWindowFocus: false,
  });
}

export function useSaveUserSignature() {
  const queryClient = useQueryClient();

  return useMutation(async (signature: UserSignature) => {
    const result = await api.saveUserSignature(signature);
    queryClient.setQueryData(["user", "signatures"], result);
  });
}
